import React from "react";
import Courses from "./Courses";

function CourseHome() {
  return (
    <div name="courses">
      <Courses />
    </div>
  );
}

export default CourseHome;
